import React, { useEffect, useState } from "react";
import { DropdownProps, Form, FormGroup, Grid, Icon, InputOnChangeData, Modal, Segment, Statistic } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import errors from "../../Utils/ExtractErrors";
import ConsultaRepository, { IConsultaResumoRepresentante } from "../../Repositories/ConsultaRepository";
import AgentRepository from "../../Repositories/AgentsRepository";
import { GetUser } from "../../services/auth";

interface IProps {
    representanteId: string;
    onSuccess?: VoidFunction;
}

interface IState {
    open: boolean;
    loading: boolean;
    resumo: IConsultaResumoRepresentante;
    updating: boolean;
    amount: string;
    representante: string;
    limiteAtual: number;
}

const initialState: IState = {
    open: false,
    loading: false,
    updating: false,
    resumo: {
        aprovados: 0,
        reprovados: 0
    },
    amount: "",
    representante: "",
    limiteAtual: 0
}

export default function ConsultSummary(props: IProps) {
    const [state, setState] = useState<IState>(initialState);

    useEffect(() => {
        if (!state.open) {
            setState(initialState);
        }
    }, [state.open]);

    function handleOpen() {
        setState(state => ({ ...state, open: true }));
        load();
    }

    function handleClose() {
        setState(initialState);
    }

    async function handleUpdateLimit() {
        setState(state => ({ ...state, updating: true }));
        try {
            const response = await ConsultaRepository.UpdateLimit(props.representanteId, { limite: parseInt(state.amount) });
            setState(initialState);
            if (props.onSuccess) {
                props.onSuccess();
            }
            toast(response.message, { position: "top-center", type: "success" });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });

            setState(state => ({ ...state, updating: false }));
        }
    }

    async function load() {
        setState(state => ({ ...state, loading: true }));
        try {
            const [resumo, representante, limites] = await Promise.all([
                ConsultaRepository.GetResumoRepresentante(props.representanteId),
                AgentRepository.GetById(props.representanteId),
                ConsultaRepository.LimitAvailable(props.representanteId)

            ]);
            setState(state => ({
                ...state,
                resumo: resumo,
                representante: representante.nome,
                limiteAtual: limites.limit,
                loading: false
            }));
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });

            setState(state => ({ ...state, loading: false }));
        }
    }

    function handleOnChangeInput(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) {
        setState(state => ({ ...state, [data.name]: data.value }));
    }

    const adminButton = (
        <>
            {GetUser().role === "Admin" &&
                <Form>
                    <FormGroup widths="equal">
                        <Form.Input
                            name="amount"
                            fluid
                            value={state.amount}
                            onChange={handleOnChangeInput}
                            placeholder="Digite o valor para adicionar ou subtrair"
                        />
                        <Form.Button
                            color="pink"
                            icon="plus"
                            labelPosition="left"
                            fluid
                            content="ADICIONAR/REMOVER"
                            onClick={handleUpdateLimit}
                            loading={state.updating}
                            disabled={state.amount.length === 0}
                        />
                    </FormGroup>
                </Form>

            }
        </>
    );

    const content = (
        <Modal.Content>
            <Form>
                <FormGroup widths="equal">
                    <Form.Input
                        readOnly
                        fluid
                        label="REPRESENTANTE:"
                        value={state.representante}
                    />
                    <Form.Input
                        readOnly
                        fluid
                        label="LIMITE ATUAL:"
                        value={state.limiteAtual}
                    />
                </FormGroup>
            </Form>
            <Segment placeholder>
                <Grid columns={3} textAlign="center">
                    <Grid.Column>
                        <Statistic color="green">
                            <Statistic.Label content="APROVADOS"></Statistic.Label>
                            <Statistic.Value>
                                <Icon name="thumbs up" size="small" />
                                {" "}{state.resumo.aprovados}
                            </Statistic.Value>
                        </Statistic>
                    </Grid.Column>                    
                    <Grid.Column>
                        <Statistic color="red">
                            <Statistic.Label content="REPROVADOS"></Statistic.Label>
                            <Statistic.Value>
                                <Icon name="thumbs down" size="small" />
                                {" "}{state.resumo.reprovados}
                            </Statistic.Value>
                        </Statistic>
                    </Grid.Column>
                    <Grid.Column>
                        <Statistic color="blue">
                            <Statistic.Label content="RESTANTE"></Statistic.Label>
                            <Statistic.Value>
                                <Icon name="search" size="small" />
                                {" "}{state.limiteAtual - (state.resumo.aprovados + state.resumo.reprovados)}
                            </Statistic.Value>
                        </Statistic>
                    </Grid.Column>
                </Grid>
            </Segment>
            {adminButton}
        </Modal.Content>

    );
    return (
        <ModalApp
            open={state.open}
            loading={state.loading}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title={"Resumo de consultas"}
            content={content}
            trigger={{
                icon: "list",
                color: "violet"
            }}
            cancelText="Fechar"
        />
    );
}
